import { render, staticRenderFns } from "./CancelInspections.vue?vue&type=template&id=6f2566cf&scoped=true&"
import script from "./CancelInspections.vue?vue&type=script&lang=ts&"
export * from "./CancelInspections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2566cf",
  null
  
)

export default component.exports